import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mostrarModulo, actualizarMensaje } from '../../redux/actions/actGlobal';
import { Button } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import Typography from '@material-ui/core/Typography';
import TareasTerminadas from '../general/TareasTerminadas';
import emma_w from '../../global/imagenes/emma_w.png';
import emma_s1 from '../../global/imagenes/emma_s1.png';
import {
	obtenerValores,
	obtenerPermisosValor,
	formulario,
	crear_form_data,
	consulta
} from '../../global/js/funciones';

import Respuestas from './Respuestas';


class Encuesta extends Component {
	constructor(props) {
		super(props);
		this.state = {
			iniciar:false,
			preguntas:[],
			listaRespuesta:[],
			open:false,
			message:"Cargando..",
			token: null,
			seguir: false,
			cargando: false, 
			terminado: false
		};
		this.cambiarEstado = this.cambiarEstado.bind(this);
	}

	async componentDidMount() {
		const { mostrarModulo} = this.props;
		const { tokenEcuesta } = this.props.match.params;
		mostrarModulo({ ruta: '/encuesta', nombre: 'encuesta' });
		// valor de la generica 65
		this.setState({cargando: true});
		let preguntas = await obtenerValores(65);
		preguntas = preguntas.sort((a, b) => a.valorc - b.valorc)
		let aux;
		for (let index = 0; index < preguntas.length; index++) {
			aux = await obtenerPermisosValor(preguntas[index].id);
			preguntas[index].respuestas = aux.map(element => element.secundario);
		}
		let listaRespuesta = this.listaRespuesta(preguntas);
		this.cambiarEstado({preguntas,listaRespuesta})
		
		let token = await this.validarToken(tokenEcuesta);
		if( token.successfull == true){
			this.cambiarEstado({
				token,
				seguir: true,
				message:"¡Click sobre el botón iniciar, por favor!"
			});
		}else{
			this.cambiarEstado({message:"¡El token ya no es valido o ya ha respondido la encuesta con anterioridad!"});
		}
		this.setState({cargando: false});
	}

	async componentDidUpdate(prevProps, prevState) {

	}

	validarToken = (token) =>{
		return new Promise((resolve) => {
			consulta(`api/v1.0/matriculas/encuesta_crear/${token}`, null, null, (error, estado, resp) => {
				resolve(resp);
			});
		});
	}

	cambiarEstado(state) {
		this.setState(state);
	}

	listaRespuesta=(preguntas)=>{
		return preguntas.map( pregunta => {
			let obligatorio = pregunta.valora
			return {
				obligatorio: (
					obligatorio != null 
					&& obligatorio.toLowerCase() == "obligatoria")
					? true
					: false,
				respuesta: null,
				idPregunta: pregunta.id,
				tipo: pregunta.valorb,
			}
		});
	}

	responder = (index,respuesta)=>{
		let { listaRespuesta } = this.state;
		listaRespuesta[index].respuesta = respuesta;
		this.cambiarEstado({ listaRespuesta });
	}

	hayObligatorio=()=>{
		const { listaRespuesta } = this.state;
		for (const index in listaRespuesta) {
			if (listaRespuesta[index].obligatorio == true && listaRespuesta[index].respuesta == null) return true; 
		}
		return false;
	}

	arrayToString = () => {
		let { listaRespuesta } = this.state;
		let listaEnviar = listaRespuesta.map(item => {
			let nuevoItem = { ...item }; 
			if (Array.isArray(nuevoItem.respuesta)) {
				nuevoItem.respuesta = nuevoItem.respuesta.toString();
			}
			return nuevoItem;
		})
		return JSON.stringify(listaEnviar);
	}

	enviarRespuesta= async ()=>{
		this.setState({ cargando: true })
		if(this.hayObligatorio()){
			let message = "Hay preguntas obligatorias sin respuesta.";
			this.cambiarEstado({ message, cargando: false })
			actualizarMensaje({ titulo: message, tipo: 'info', mostrar: true, tiempo: 6000 });
			this.handleClick();
		}else{
			const { tokenEcuesta } = this.props.match.params;
			let data = {
				token: JSON.stringify(this.state.token.token),
				respuestas: this.arrayToString(),
				tokenEcuesta
			}
			data = await crear_form_data( data );
			await formulario(
				`api/v1.0/matriculas/encuesta_guardar`,
				data, 
				"POST", 
				(err,estado,data)=>{
					if(!err){
						let {actualizarMensaje} = this.props;
						let message = "Se ha almacenado la encuenta exitosamente";
						actualizarMensaje({ titulo: message, tipo: 'success', mostrar: true, tiempo: 6000 });
						this.setState({ terminado: true, cargando: false })
					}
				}
			);
		}
	}

	handleClick = () => {
		this.cambiarEstado({open:true});
	};

	handleClose = () => {
		this.cambiarEstado({open:false});
	};

	render() {
		const { 
			iniciar,
			preguntas,
			open,
			message,
			seguir,
			terminado,
			cargando
		} = this.state;	

		return (
			<div>
				{
					!terminado ?  (
						!iniciar ? (
							<div>
								{seguir ?
									<>
										<TareasTerminadas marginBottom={"3px"} mensaje={'¡Nos encantaría conocer tu opinión!'} marginTop='7%' imagen={emma_w} widthImg="7%" />
										<Typography style={{ 'paddingLeft': '20%', 'paddingRight': '20%', 'marginBottom': '10px', 'textAlign': 'center' }} variant="subtitle1" color="textSecondary" component="p">Tu experiencia es muy importante para nosotros y nos ayuda a mejorar continuamente. Desde la Dirección de Registros, te invitamos a completar nuestra encuesta de satisfacción. Tu opinión nos permitirá seguir ofreciendo el mejor servicio posible. La encuesta es breve y tomará solo unos minutos de tu tiempo. ¡Agradecemos mucho tu participación!</Typography>
									</>
									:
									<TareasTerminadas
										mensaje={message}
										marginTop='7%'
										imagen={emma_w}
										widthImg='7%'
									/>
								}

								<div style={{
									display:"flex",
									width:"100%",
									justifyContent: "center",

								}}>
									{
										seguir  && (
											<Button 
												variant="contained"
												color="primary"
												onClick={()=>this.cambiarEstado({iniciar:!iniciar})}
											>
												Iniciar
											</Button>
										)
									}	
								</div>
							</div>
						) :
							!cargando ?
								(
									<div>
										{
											preguntas.map((pregunta, index) => {
												return <Respuestas
													key={index}
													index={index}
													pregunta={pregunta.nombre}
													tipo={pregunta.valorb}
													obligatoria={pregunta.valora}
													numeroI={pregunta.valorc}
													respuestas={pregunta.respuestas}
													responder={this.responder}
													listaRespuesta={this.state.listaRespuesta}
													cargando={this.state.cargando}
													guardado={this.state.guardado}

												/>
											})
										}
										<div style={{
											width: '70%',
											height: '50px',
											marginLeft: '24px'
										}}>
											<Button
												variant="contained"
												color="primary"
												onClick={this.enviarRespuesta}
											>
												Guardar
											</Button>
										</div>
									</div>

								) : <TareasTerminadas mensaje='Enviando ..' marginTop='7%' imagen={emma_w} widthImg='7%' cargando={true} />

					): (
						<TareasTerminadas mensaje='Esta encuenta ha finalizado con exito' marginTop='7%' imagen={emma_s1} widthImg='7%' />
					)
				}
				<div >
					<Snackbar style={{ width:"100%" }} 
					message={message} 
					open={open} 
					autoHideDuration={6000} 
					severity="success" 
					onClose={this.handleClose}>
						
					</Snackbar>
				</div>
    		</div>
		);
	}
}


const mapStateToProps = (state) => {
	let { usuario } = state.redGlobal;
	return {
		usuario,
	};
};

const mapDispatchToProps = {
	mostrarModulo,
	actualizarMensaje
};

export default connect(mapStateToProps, mapDispatchToProps)(Encuesta);
